import { Fragment } from "react";
import ImageRowItem from "../../../../components/ImageRowItem";
import DetailPreview from "../../../../components/Preview/DetailPreview";
import { prepareSummaryList } from "../../CartSummary/summary-utils";
import { getStyle } from "../../../../hooks/use-styles";
import { prepareCartTotal } from "../../ShoppingCart/CartDetailsView/cart-details-utils";

import './style.css';

const SummaryList = ({ detail, supplierSubTitle }) => {
  const { payableAmount, paidAmount, supplier } = detail;

  return (
    <Fragment>
      <ImageRowItem
        title={supplier.name}
        subTitle={supplierSubTitle}
        titleClass={"font-16-bold-500-lh-20"}
        subTitleClass={"font-12-normal-400-lh-14"}
        className={"supplier-summary-image"}
        imageSrc={`${supplier.referenceUrlLogo}?size=xs`}
      />

      <DetailPreview
        inlineFlex={true}
        className={"summary-list-item"}
        detailInfo={prepareSummaryList(detail)}
        labelClass={"font-14-normal-400-lh-18"}
        valueClass={"font-14-normal-400-lh-18"}
        labelStyle={{ color: getStyle("secondaryGray") }}
        valueStyle={{ color: getStyle("primaryBlack") }}
      />

      <div className="border-divider mt-20 mb-20" />

      <div className="summary-total-information">
        <DetailPreview
          inlineFlex={true}
          className={"full-width font-14-regular-400-lh-22 mb-8"}
          labelClass={"font-20-bold-500"}
          detailInfo={prepareCartTotal({
            totalAmount: payableAmount || paidAmount,
          })}
        />
      </div>
    </Fragment>
  );
};

export default SummaryList;
